import { Button, Stack, styled, Text } from '@ltvco/refresh-lib/theme';

export const StyledLoginInformationContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
}));

export const StyledLoginInformationHeader = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const StyledMobileLayout = styled(Stack)(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
  },
}));

export const StyledDesktopLayout = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledLoginInformationTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const StyledPasswordRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
});

export const StyledUpdatePasswordButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
    alignSelf: 'center',
    maxWidth: '100%',
  },
}));
